import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { SUPPLIER_SPECIAL_OFFERS_DELETED } from '../../store/supplier-special-offers-actions';
import {
    SUPPLIER_SPECIAL_OFFERS_LIST_ERROR,
    SUPPLIER_SPECIAL_OFFERS_LIST_FETCH,
    SUPPLIER_SPECIAL_OFFERS_LIST_RECEIVE,
} from './supplier-special-offers-list-actions';
import { SupplierSpecialOffer } from '../../models/supplier-special-offer';

export interface SupplierSpecialOffersListReducerState {
    items: PaginatedResponse<SupplierSpecialOffer>;
    requesting: boolean;
}

const initialSupplierSpecialOffersListReducerState: SupplierSpecialOffersListReducerState = {
    items: { limit: 10, page: 0, total: 0, items: [] },
    requesting: false,
};

export const supplierSpecialOffersListReducer = (
    state: SupplierSpecialOffersListReducerState = initialSupplierSpecialOffersListReducerState,
    action: AnyAction
): SupplierSpecialOffersListReducerState => {
    switch (action.type) {
        case SUPPLIER_SPECIAL_OFFERS_LIST_FETCH: {
            return {
                ...state,
                requesting: true,
            };
        }

        case SUPPLIER_SPECIAL_OFFERS_LIST_RECEIVE: {
            return {
                ...state,
                requesting: false,
                items: action['supplierSpecialOffers'],
            };
        }

        case SUPPLIER_SPECIAL_OFFERS_LIST_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        case SUPPLIER_SPECIAL_OFFERS_DELETED: {
            return {
                ...state,
                items: {
                    ...state.items,
                    items: state.items.items.filter(item => item.id !== action['id']),
                    total: state.items.total - 1,
                },
            };
        }

        default: {
            return state;
        }
    }
};
